import React from 'react';
import { AutoAwesome } from 'tuui';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { CREATIVE_TYPE } from '../../../config';
import { AIGeneratedImagesTab, MediaLibraryTab, RecommendedMediaTab } from '../components/MediaTabs';
import { CREATIVE_EDITOR_TABS } from './index';

export const thumbnailTabItems = [
    {
        id: CREATIVE_EDITOR_TABS.MEDIA_LIBRARY,
        caption: {
            id: 'creative.editor.tab.mediaLibrary.caption',
            default: 'Media Library',
        },
        component: MediaLibraryTab,
        metricsAttributes: () => ({
            'data-metrics-event-name': GTM_EVENTS.USABILITY,
            'data-metrics-component': 'MediaLibraryTab',
        }),
        visibilityCondition: ({ accountConfig }) =>
            accountConfig[FEATURE_FLAGS.MEDIA_LIBRARY_IMAGE_DRAWERS] === 'true' ||
            accountConfig[FEATURE_FLAGS.MEDIA_LIBRARY_VIDEO_DRAWERS] === 'true',
    },
    {
        id: CREATIVE_EDITOR_TABS.AI_GENERATED,
        caption: {
            id: 'creative.editor.tab.aiGenerated.caption',
            default: 'AI Generated',
        },
        component: AIGeneratedImagesTab,
        metricsAttributes: ({ campaignId }) => ({
            'data-metrics-event-name': GTM_EVENTS.USABILITY,
            'data-metrics-component': 'AIGeneratedImagesTab - Generate With AI',
            'data-metrics-taboola-campaign-id': campaignId,
        }),
        visibilityCondition: ({ creativeType, accountConfig, permissionsMap }) =>
            accountConfig[FEATURE_FLAGS.GEN_AI_AB_TEST_WITH_AI] === 'true' &&
            (accountConfig[FEATURE_FLAGS.AI_IMAGE_GENERATION_TAB_ENABLED] === 'true' ||
                permissionsMap['AI_IMAGE_GENERATION']) &&
            creativeType !== CREATIVE_TYPE.MOTION,
        icon: <AutoAwesome />,
    },
    {
        id: CREATIVE_EDITOR_TABS.RECOMMENDED_MEDIA,
        caption: {
            default: 'Stock Images',
        },
        component: RecommendedMediaTab,
        metricsAttributes: () => ({
            'data-metrics-event-name': GTM_EVENTS.USABILITY,
            'data-metrics-component': 'RecommendedMediaTab',
        }),
    },
];
